// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__fZLMx","signatureBlock":"Footer_signatureBlock__2kJI8","signature":"Footer_signature__1Z8rg"};